import { ButtonProps, useMediaQuery, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const ButtonContainedGrey = (props: ButtonProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Button
      {...props}
      sx={{
        backgroundColor: 'grey.200',
        color: 'grey.600',
        '&:hover': {
          backgroundColor: 'grey.300',
          color: 'grey.900',
        },
        '&:disabled': {
          backgroundColor: 'grey.200',
        },
      }}
      size={isMobile ? 'small' : 'medium'}
      variant='contained'
      disableElevation
    />
  );
};
